// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Config from "../../../Config.bs.js";
import * as InjectedConnector from "@web3-react/injected-connector";

var InjectedConnector$1 = {};

var WalletConnectConnector = {};

var TorusConnector = {};

var PortisConnector = {};

var FortmaticConnector = {};

var SquarelinkConnector = {};

var injected = new InjectedConnector.InjectedConnector({
      supportedChainIds: Config.availableNetworkIds
    });

export {
  InjectedConnector$1 as InjectedConnector,
  WalletConnectConnector ,
  TorusConnector ,
  PortisConnector ,
  FortmaticConnector ,
  SquarelinkConnector ,
  injected ,
  
}
/* injected Not a pure module */
